import {useFormik} from 'formik'
import {InputDate} from '../../../../../_gori/partials/widgets'
import {MessageDateTimeRangePayload, MessageItemCommonProps} from '../../definitions'
import moment from 'moment'
import {MessageItemWrapper} from './MessageItemWrapper'

type MessageItemDatePickerProps = MessageItemCommonProps<MessageDateTimeRangePayload>

const DATE_NAME = 'date'

export const MessageItemDatePicker = ({message}: MessageItemDatePickerProps) => {
  const formik = useFormik({
    initialValues: {
      [DATE_NAME]: null,
    },
    onSubmit: (values) => {
      console.log('values: ', values)
    },
  })
  return (
    <MessageItemWrapper message={message} className='bg-primary'>
      <InputDate
        className='w-175px'
        min={moment()}
        name={DATE_NAME}
        formik={formik}
        inputClassName='overflow-hidden rounded-2'
      />
    </MessageItemWrapper>
  )
}
